import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  AdminUserDetailPage,
  type AdminUserDetailPageProps,
} from '../ui/admin/AdminUserDetailPage';

/**
 * AdminUserDetailPageContainer - Entry point for rendering admin user detail page in Rails
 */
export function AdminUserDetailPageContainer(props: AdminUserDetailPageProps) {
  return <AdminUserDetailPage {...props} />;
}

/**
 * Mount function for rendering from Rails
 */
export function mountAdminUserDetailPage(
  container: HTMLElement,
  props: AdminUserDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminUserDetailPageContainer {...props} />);
  return root;
}

export default AdminUserDetailPageContainer;
